import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { PapiAdoptableOffer, PapiDeviation } from '@wix/da-papi-types';
import { ListItemDiv } from '@wix/da-ds/pkg/List/ListItem';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import { formatDollars } from '../../../../../../utils/formatting';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import BasicUserLink from '../../../../../../User/_partials/BasicUserLink';
import { useViewOffersAction } from '../../hooks';
import s from './OfferList.scss';

const OFFERS_DISPLAY_MAX = 3;

interface Props {
  deviation: PapiDeviation;
  offers: PapiAdoptableOffer[];
  className?: string;
}

const OfferList: React.FC<Props> = ({ deviation, offers, className }) => {
  const { t } = useTranslation();
  const [handleShowMoreClick, showMoreBiData] = useViewOffersAction(deviation, {
    sectionname: 'side-rail',
  });

  return (
    <div className={c(s['root'], className)}>
      <div className={s['offers']}>
        {offers.slice(0, OFFERS_DISPLAY_MAX).map(
          (offer, index) =>
            offer.from && (
              <ListItemDiv
                key={index}
                className={s['offer']}
                compact
                prefix={<UserAvatar user={offer.from} size={24} />}
                label={
                  <BasicUserLink
                    user={offer.from}
                    className={s['user-name-link']}
                  >
                    {offer.from.username}
                  </BasicUserLink>
                }
                suffix={
                  <span className={s['offer-price']}>
                    {formatDollars(offer.dollarPrice)}
                  </span>
                }
              />
            )
        )}
      </div>

      {offers.length > OFFERS_DISPLAY_MAX && (
        <TextButton
          className={s['show-more-button']}
          size="medium"
          variant="main"
          onClick={handleShowMoreClick}
          biData={showMoreBiData}
        >
          {t('sidebar.exclusives.offerList.cta.showAllOffers', {
            offersCount: offers.length,
          })}
        </TextButton>
      )}
    </div>
  );
};

OfferList.displayName = 'OfferList';

export default OfferList;
